import { ZipDetailsResponse } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

interface IStartPollingPayload {
  corpId: string;
  dinerId: string;
  dateFrom: string;
  dateTo: string;
  query: string;
}

export const getOrderReceiptsZipDetails = async (
  corpId: string
): Promise<ZipDetailsResponse> => {
  return sdk.http.get(
    `/corp-admin/${corpId}/orders/receipt/pdf/bulk-generation/details`
  );
};

export const startBulkPdfGeneration = async ({
  corpId,
  dinerId,
  dateFrom,
  dateTo,
  query,
}: IStartPollingPayload): Promise<IAsyncTaskResponse> => {
  return sdk.http.post(
    `/corp-admin/${corpId}/orders/receipt/pdf/bulk-generation/start`,
    {
      corp_id: corpId,
      diner_id: dinerId,
      date_from: dateFrom,
      date_to: dateTo,
      query,
    }
  );
};
